import React, {useEffect, useState} from 'react';
import {Link, Navigate, useNavigate} from "react-router-dom";
import {Card, Col, Container, Label, Row} from 'reactstrap';


import withRouter from "../../../Components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import {useFormik} from "formik";
import axios from 'axios';
import AuthSlider from './authCarousel';
import AuthService from "../util/AuthService";
import ApiService from "../util/ApiService";


import {useDispatch} from "react-redux";
import Swal from "sweetalert2"; // Importa o LoadingScreen

const Login = (props) => {

    document.title = "Login | Plantão Rápido";
    const history = useNavigate();
    const [redirect, setRedirect] = useState(false);
    const [showNewsAccess, setShowNewsAccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const [errorMessageUpdate, setErrorMessageUpdate] = useState("");
    const [users, setUsers] = useState({
        email: "",
        password: "",
    });

    const [usersUpdate, setUsersUpdate] = useState({
        cpf: "",
        email: "",
        email_confirm: "",
    });
    const [loggedIn, setLoggedIn] = useState(false);
    const [footerTitle, setFooterTitle] = useState("MEDR");
    const [footerUrl, setFooterUrl] = useState("https://medr.com.br/");
    const [showRegister, setShowRegister] = useState(false);
    const [companyName, setCompanyName] = useState("Plantão Rápido");

    useEffect(() => {
        const domain = window.location.hostname;

        const updateCustomData = () => {
            try {
                const cachedData = localStorage.getItem(`custom_images_${domain}`);
                const cachedImages = cachedData ? JSON.parse(cachedData) : {};
                if (cachedImages.titleFooter) {
                    setFooterTitle(cachedImages.titleFooter);
                }
                if (cachedImages.companyUrlFooter) {
                    setFooterUrl(cachedImages.companyUrlFooter);
                }
                if (cachedImages.externalUserRegistration !== undefined) {
                    setShowRegister(cachedImages.externalUserRegistration);
                }
                if (cachedImages.title) {
                    setCompanyName(cachedImages.title);
                }
            } catch (error) {
                console.error('Erro ao carregar dados customizados:', error);
            }
        };

        updateCustomData();

        const interval = setInterval(updateCustomData, 500);
        const timeout = setTimeout(() => clearInterval(interval), 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    useEffect(() => {
        // Verificar se o usuário está logado ao montar o componente
        const checkLoggedIn = () => {
            const storedUser = localStorage.getItem("users");
            if (storedUser) {
                setLoggedIn(true);
            }
        };

        checkLoggedIn();
    }, []);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setUsers((prevUsers) => ({
            ...prevUsers,
            [name]: value,
        }));
    };


    const handleChangeUpdate = (event) => {
        const { name, value } = event.target;

        setUsersUpdate((prevUsers) => {
            const updated = { ...prevUsers, [name]: value };

            // Validação ao digitar: mostra erro se os campos forem diferentes
            if (updated.email && updated.email_confirm && updated.email !== updated.email_confirm) {
                setErrorMessageUpdate("Os e-mails não coincidem.");
            } else {
                setErrorMessageUpdate(""); // Limpa o erro se forem iguais
            }

            return updated;
        });
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsLoading(true); // Inicia o carregamento
        setSuccessMessage("");
        setErrorMessage("");
        try {

            const res = await axios.post(process.env.REACT_APP_URL_API + "login", users);
            AuthService.login(res.data);
            setRedirect(true);
        } catch (error) {

            if (error?.response?.status === 406) {
                setUsersUpdate((prev) => ({
                    ...prev,
                    cpf: users.email,
                }));

                setShowNewsAccess(true);
            } else {
                ApiService.handleApiError(error);
            }
        } finally {
            setIsLoading(false); // Finaliza o carregamento
        }
    };


    const handleSubmitUpdate = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsLoading(true); // Inicia o carregamento

        try {

            const response = await axios.put(process.env.REACT_APP_URL_API + "users/update-email", usersUpdate);

            if (response.code === 200) {
                setShowNewsAccess(false);
                setErrorMessage("");
                setUsersUpdate({
                    cpf: "",
                    email: "",
                    email_confirm: "",
                });
                setSuccessMessage(`<i class="fa fa-envelope me-2"></i> Seu e-mail foi atualizado com sucesso, por favor confirmar em sua caixa de entrada.`);
            }

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setIsLoading(false); // Finaliza o carregamento
        }
    };

    // Redirecionar para /admin se o usuário estiver logado
    useEffect(() => {
        if (loggedIn || redirect) {
            window.location.href = "/admin/dashboard";
        }
    }, [loggedIn, redirect]);

    document.title = "Login | Plantão Rápido";
    return (
        <React.Fragment>
            <div
                className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>

                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider/>

                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">


                                                {showNewsAccess ? (
                                                    // Se for true
                                                    <>

                                                        <div>
                                                            <h5 className="text-primary">Bem vindo ao seu Primeiro
                                                                Acesso!</h5>
                                                            <p className="text-muted">Vamos precisar cadastrar seu
                                                                e-mail e uma nova senha.</p>
                                                        </div>
                                                        <div className="mt-4">
                                                            <form onSubmit={handleSubmitUpdate}>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="username"
                                                                           className="form-label">CPF/CNPJ</Label>
                                                                    <input
                                                                        disable={true}
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="cpf"
                                                                        value={usersUpdate.cpf}
                                                                        onChange={handleChangeUpdate}
                                                                        placeholder="CPF ou CNPJ"
                                                                    />
                                                                </div>

                                                                <div className="mb-3">
                                                                    <Label htmlFor="username"
                                                                           className="form-label">Email</Label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="email"
                                                                        value={usersUpdate.email}
                                                                        onChange={handleChangeUpdate}
                                                                        placeholder="Digite seu Email"
                                                                    />
                                                                </div>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="username"
                                                                           className="form-label">Confirmar Email</Label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="email_confirm"
                                                                        value={usersUpdate.email_confirm}
                                                                        onChange={handleChangeUpdate}
                                                                        placeholder="Confirmar seu Email"
                                                                    />
                                                                </div>

                                                                {errorMessageUpdate && (
                                                                    <div className="alert alert-danger mt-2"
                                                                         role="alert">
                                                                        <div
                                                                            dangerouslySetInnerHTML={{__html: errorMessageUpdate}}/>
                                                                    </div>
                                                                )}

                                                                {successMessage && (
                                                                    <div className="alert alert-info mt-2" role="alert">
                                                                        <div dangerouslySetInnerHTML={{ __html: successMessage }} />
                                                                    </div>
                                                                )}

                                                                <div className="mt-4">
                                                                    <button className="btn btn-primary w-100"
                                                                            type="submit" disabled={isLoading}>
                                                                        {isLoading ? (
                                                                            <>
                                                                                <span
                                                                                    className="spinner-border spinner-border-sm me-2"
                                                                                    role="status"
                                                                                    aria-hidden="true"></span>
                                                                                Registrando...
                                                                            </>
                                                                        ) : (
                                                                            "Registrar e-mail"
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </form>


                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div>
                                                            <h5 className="text-primary">Bem vindo!</h5>
                                                            <p className="text-muted">Faça o login para continuar - {companyName}</p>
                                                        </div>
                                                        <div className="mt-4">
                                                            <form onSubmit={handleSubmit}>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="username"
                                                                           className="form-label">Login</Label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="email"
                                                                        value={users.email}
                                                                        onChange={handleChange}
                                                                        placeholder="Digite seu Email, CPF ou CNPJ"
                                                                    />
                                                                </div>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="username"
                                                                           className="form-label">Senha</Label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="password"
                                                                        name="password"
                                                                        value={users.password}
                                                                        onChange={handleChange}
                                                                        placeholder="Digite a senha"
                                                                    />
                                                                </div>

                                                                {errorMessage && (
                                                                    <div className="alert alert-danger mt-2"
                                                                         role="alert">
                                                                        <div
                                                                            dangerouslySetInnerHTML={{__html: errorMessage}}/>
                                                                    </div>
                                                                )}

                                                                {successMessage && (
                                                                    <div className="alert alert-info mt-2" role="alert">
                                                                        <div dangerouslySetInnerHTML={{ __html: successMessage }} />
                                                                    </div>
                                                                )}

                                                                <div className="mt-4">
                                                                    <button className="btn btn-primary w-100"
                                                                            type="submit" disabled={isLoading}>
                                                                        {isLoading ? (
                                                                            <>
                                                                                <span
                                                                                    className="spinner-border spinner-border-sm me-2"
                                                                                    role="status"
                                                                                    aria-hidden="true"></span>
                                                                                Entrando...
                                                                            </>
                                                                        ) : (
                                                                            "Entrar"
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </form>

                                                            <div className="text-center forgotpass">
                                                                <Link to="/forgot-password">Esqueceu sua senha?</Link>
                                                            </div>

                                                        </div>
                                                    </>
                                                )}


                                                {showRegister && (
                                                    <div className="mt-4 text-center">
                                                        <p className="mb-0">Não tem uma conta? <Link to="/register"
                                                                                                     className="fw-semibold text-primary text-decoration-underline"> Registrar </Link>
                                                        </p>
                                                    </div>
                                                )}


                                            </div>
                                        </Col>

                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} <a className="text-reset text-decoration-none" target="_blank" rel="noopener noreferrer" href={footerUrl}>{footerTitle}</a>. Todos Direitos Reservados</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>

            </div>
        </React.Fragment>
    );
};

export default withRouter(Login);